// @ts-nocheck
import { createSelector } from 'reselect';

export const getMapStore = store => store.reportingMap;

export const getPositionFit = createSelector([getMapStore, (store, id) => id], (moduleStore, id) => {
  const newStore = { ...moduleStore[id] };
  if (newStore && newStore.fit) {
    const featureToBBox = newStore.fit.type === 'Feature' ? newStore.fit : turf.feature(newStore.fit);
    const bbox = turf.bbox(featureToBBox);
    newStore.fit = new mapboxgl.LngLatBounds(bbox).toArray();
  }
  return newStore.fit || null;
});
export const getMapType = createSelector(
  [getMapStore, (store, id) => id],
  (moduleStore, id) => moduleStore[id].type || null
);
export const getAllBounds = createSelector([getMapStore], moduleStore => {
  const maps = {};
  Object.keys(moduleStore).forEach(mapId => {
    maps[mapId] = moduleStore[mapId].bounds;
  });
  return maps || {};
});
export const getAllZooms = createSelector([getMapStore], moduleStore => {
  const maps = {};
  Object.keys(moduleStore).forEach(mapId => {
    maps[mapId] = moduleStore[mapId].zoom;
  });
  return maps || {};
});
